import React from "react";
import { useState } from "react";
import ProductOverlay from "./ProductOverlay";
import { ProductType, type AppProduct, type AvailableGoal } from "@shared/interfaces/product";
import ProductItem from "./ProductItem.tsx";
import type { SelectedProducts } from "../../types/product";
import ProductManager from "../../lib/Product/ProductManager.ts";

interface Props {
    selectedGoal: AvailableGoal,
    selectedProducts: SelectedProducts,
    onProductsUpdate: (products: SelectedProducts) => void
}

const itemListOrder = [
    ProductType.SOLAR_PANEL,
    ProductType.BATTERY_STORAGE,
    ProductType.INVERTER,
    ProductType.ACCESSORY,
    ProductType.MOUNTING_SYSTEM,
    ProductType.SERVICE_PACKAGE,
    ProductType.OTHERS
];

const ProductList: React.FC<Props> = ({ selectedGoal, selectedProducts, onProductsUpdate, }) => {
    const [overlayState, setOverlayState] = useState<Record<string, boolean>>({});

    const handleProductSelection = (selectedProduct: AppProduct) => {
        onProductsUpdate({...selectedProducts, [selectedProduct.type]: selectedProduct});
    };

    return (
        itemListOrder.map((type, index) => {
            const items = ProductManager.getProductsByTypeAndGoal(type, selectedGoal);
            if (!selectedProducts[type] || Object.values(items).length === 0) return;

            return (
                <div key={selectedProducts[type].type}>
                    <ProductItem
                        product={selectedProducts[type]}
                        index={index}
                        handleProductClick={() => setOverlayState({ ...overlayState, [selectedProducts[type].type]: true })}
                    />
                    <ProductOverlay
                        open={overlayState[selectedProducts[type].type] || false}
                        items={items}
                        selectedGoal={selectedGoal}
                        selectedProducts={selectedProducts}
                        currentType={type}
                        onClick={() => setOverlayState({ ...overlayState, [selectedProducts[type].type]: false })}
                        onProductSelect={handleProductSelection}
                    />
                </div>
            );
        })
    );
};

export default ProductList;
